import { createFileRoute } from "@tanstack/react-router";
import GxpQaTraining from "@/pages/GxpQaTraining";
import { GXP_TRAINING_TITLE, GXP_TRAINING_DESCRIPTION, GXP_TRAINING_IMAGE } from "@/data/gxpQaTraining";
import { buildRouteHead } from "@/lib/seo/routeHead";

export const Route = createFileRoute("/en/services/quality-assurance/regulatory-compliance-training")({
  head: () => buildRouteHead("/en/services/quality-assurance/regulatory-compliance-training", {
    title: `${GXP_TRAINING_TITLE} | QbD Group`,
    description: GXP_TRAINING_DESCRIPTION,
    ogImage: GXP_TRAINING_IMAGE,
  }),
  component: GxpQaTraining,
});
